<template>
    <div class="main_bd">
        <div class="head_title">Business Report</div>
        <div style="margin-top: 20px">
            <a-date-picker v-model="target_date" placeholder="Date" style="width: 200px;" />
            <a-select v-model="cluster" style="width: 150px; margin-left: 5px;">
                <a-select-option value="north_america">
                    North America
                </a-select-option>
                <a-select-option value="asia">
                    Southeast Asia
                </a-select-option>
            </a-select>
        </div>
        <a-row :gutter="16" style="margin-top: 20px;">
            <a-col :span="12">
                <a-card :loading="waitlist_compare_loading" :title="'Waitlist - Top 20 with ' + (waitlist_orderby == 'week_change_percent' ? 'Weekly' : 'Monthly')" style="width: 100%;">
                    <div slot="extra">
                        <a-select v-model="waitlist_sort" style="width: 80px" @change="handelSelectChange('waitlist_compare')">
                            <a-select-option value="desc">
                                Desc
                            </a-select-option>
                            <a-select-option value="asc">
                                Asc
                            </a-select-option>
                        </a-select>
                        <a-select v-model="waitlist_orderby" style="width: 150px; margin-left: 5px;" @change="handelSelectChange('waitlist_compare')">
                            <a-select-option value="week_change_percent">
                                Week-on-Week
                            </a-select-option>
                            <a-select-option value="month_change_percent">
                                Month-on-Month
                            </a-select-option>
                        </a-select>
                        <a-select v-model="waitlist_threshold" style="width: 120px; margin-left: 5px;" @change="handelSelectChange('waitlist_compare')">
                            <a-select-option :value="0">
                                Up - 0
                            </a-select-option>
                            <a-select-option :value="10">
                                Up - 10
                            </a-select-option>
                            <a-select-option :value="20">
                                Up - 20
                            </a-select-option>
                            <a-select-option :value="50">
                                Up - 30
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="topn_container">
                        <a-row :gutter="16" class="topn_item" style="background-color: #ebeef1;">
                            <a-col :span="8" style="text-align: left;">
                                <span>Merchant Name</span>
                            </a-col>
                            <a-col :span="5">
                                <span>{{ date_dict['date'] || 'Count' }}</span>
                            </a-col>
                            <a-col :span="5">
                                <span>{{ date_dict['last_week_date'] || 'W-on-W' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span>{{ date_dict['last_month_date'] || 'M-on-M' }}</span>
                            </a-col>
                        </a-row>
                        <a-row :gutter="16" class="topn_item" v-bind:key="item.sid" v-for="item in waitlist_compare_top20">
                            <a-col :span="8" style="text-align: left; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                <a href="javascript:;" @click="doShowLayer(item.sid)">{{ item.sname }}</a>
                            </a-col>
                            <a-col :span="5">
                                <span>{{ item.now_count }}</span>
                            </a-col>
                            <a-col :span="5" :class="{ topn_rise: item.week_change_percent * 1 > 0, topn_fall: item.week_change_percent * 1 < 0 }">
                                <span v-if="item.week_change_percent * 1 > 0"><a-icon type="rise" /></span>
                                <span v-else><a-icon type="fall" /></span>
                                <span style="margin-left: 5px;">
                                    {{ item.week_change_percent + '%    (' + item.last_week_count + ')' }}
                                </span>
                            </a-col>
                            <a-col :span="6" :class="{ topn_rise: item.month_change_percent * 1 > 0, topn_fall: item.month_change_percent * 1 < 0 }">
                                <span v-if="item.month_change_percent * 1 > 0"><a-icon type="rise" /></span>
                                <span v-else><a-icon type="fall" /></span>
                                <span style="margin-left: 5px;">
                                    {{ item.month_change_percent + '%    (' + item.last_month_count + ')' }}
                                </span>
                            </a-col>
                        </a-row>
                    </div>
                </a-card>
            </a-col>
            <a-col :span="12">
                <a-card :loading="reservation_compare_loading" :title="'Reservation - Top 20 with ' + (reservation_orderby == 'week_change_percent' ? 'Weekly' : 'Monthly')" style="width: 100%;">
                    <div slot="extra">
                        <a-select v-model="reservation_sort" style="width: 80px" @change="handelSelectChange('reservation_compare')">
                            <a-select-option value="desc">
                                Desc
                            </a-select-option>
                            <a-select-option value="asc">
                                Asc
                            </a-select-option>
                        </a-select>
                        <a-select v-model="reservation_orderby" style="width: 150px; margin-left: 5px;" @change="handelSelectChange('reservation_compare')">
                            <a-select-option value="week_change_percent">
                                Week-on-Week
                            </a-select-option>
                            <a-select-option value="month_change_percent">
                                Month-on-Month
                            </a-select-option>
                        </a-select>
                        <a-select v-model="reservation_threshold" style="width: 120px; margin-left: 5px;" @change="handelSelectChange('reservation_compare')">
                            <a-select-option :value="0">
                                Up - 0
                            </a-select-option>
                            <a-select-option :value="10">
                                Up - 10
                            </a-select-option>
                            <a-select-option :value="20">
                                Up - 20
                            </a-select-option>
                            <a-select-option :value="50">
                                Up - 30
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="topn_container">
                        <a-row :gutter="16" class="topn_item" style="background-color: #ebeef1;">
                            <a-col :span="8" style="text-align: left;">
                                <span>Merchant Name</span>
                            </a-col>
                            <a-col :span="5">
                                <span>{{ date_dict['date'] || 'Count' }}</span>
                            </a-col>
                            <a-col :span="5">
                                <span>{{ date_dict['last_week_date'] || 'W-on-W' }}</span>
                            </a-col>
                            <a-col :span="6">
                                <span>{{ date_dict['last_month_date'] || 'M-on-M' }}</span>
                            </a-col>
                        </a-row>
                        <a-row :gutter="16" class="topn_item" v-bind:key="item.sid" v-for="item in reservation_compare_top20">
                            <a-col :span="8" style="text-align: left; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                                <a href="javascript:;" @click="doShowLayer(item.sid)">{{ item.sname }}</a>
                            </a-col>
                            <a-col :span="5">
                                <span>{{ item.now_count }}</span>
                            </a-col>
                            <a-col :span="5" :class="{ topn_rise: item.week_change_percent * 1 > 0, topn_fall: item.week_change_percent * 1 < 0 }">
                                <span v-if="item.week_change_percent * 1 > 0"><a-icon type="rise" /></span>
                                <span v-else><a-icon type="fall" /></span>
                                <span style="margin-left: 5px;">
                                    {{ item.week_change_percent + '%    (' + item.last_week_count + ')' }}
                                </span>
                            </a-col>
                            <a-col :span="6" :class="{ topn_rise: item.month_change_percent * 1 > 0, topn_fall: item.month_change_percent * 1 < 0 }">
                                <span v-if="item.month_change_percent * 1 > 0"><a-icon type="rise" /></span>
                                <span v-else><a-icon type="fall" /></span>
                                <span style="margin-left: 5px;">
                                    {{ item.month_change_percent + '%    (' + item.last_month_count + ')' }}
                                </span>
                            </a-col>
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
        <a-modal :centered="true" style="overflow: scroll;" v-model="show_merchant_detail_layer" width="90%" height="100%" title="Merchant Detail" @ok="doHideLayer">
            <MerchantDetail :sid="select_sid"></MerchantDetail>
        </a-modal>
    </div>
</template>

<style>
    .topn_container {
        padding: 10px 10px;
        height: 500px;
        overflow: auto;
    }
    .topn_container .topn_item {
        padding: 10px 0;
        border-bottom: 0px solid #e8e8e8;
        text-align: center;
    }
    .topn_container .topn_item .topn_rise {
        color: #66f04a;
    }
    .topn_container .topn_item .topn_fall {
        color: #f04134;
    }
</style>

<script>
    import Vue from 'vue';
    import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
    import moment from 'moment-timezone';

    import VueSweetalert2 from "vue-sweetalert2";
    Vue.use(VueSweetalert2);

    import MerchantDetail from "../../components/MerchantReportDetail.vue";

    export default {
        name: 'daily_report',
        components: {
            MerchantDetail
        },
        data() {
            return {
                target_date: moment().add(-1, 'day'),
                cluster: 'north_america',
                date_dict: {},
                
                waitlist_sort: 'asc',
                reservation_sort: 'asc',
                waitlist_orderby: 'week_change_percent',
                reservation_orderby: 'week_change_percent',
                waitlist_threshold: 20,
                reservation_threshold: 20,

                waitlist_compare_top20: [],
                reservation_compare_top20: [],

                waitlist_compare_loading: false,
                reservation_compare_loading: false,

                show_merchant_detail_layer: false,
                select_sid: ''
            };
        },
        beforeMount() {
            let _sid = window.localStorage.getItem('sid') || '';
            let _token = window.localStorage.getItem('token') || '';

            if (!_sid || !_token) {
                window.location.replace('/login');
            }
        },
        async created() {
            this.request_data();
        },
        watch: {
            target_date() {
                this.request_data();
            },
            cluster() {
                this.request_data();
            },
        },
        mounted() {

        },
        computed: {
            ...mapGetters({
            }),
            ...mapState({
            })
        },
        methods: {
            ...mapActions({
                getReportDailyCompare: 'monitor/getReportDailyCompare',
                getReportDailyRank: 'monitor/getReportDailyRank',
            }),
            ...mapMutations({
                set_msg: 'app/APP_SET_MSG'
            }),
            request_data() {
                this.get_report_daily_compare_data('waitlist');
                this.get_report_daily_compare_data('reservation');
                this.get_report_daily_rank_data();
            },
            async get_report_daily_compare_data(business) {
                this[business + '_compare_loading'] = true;
                let post_data = {
                    business: business,
                    date: this.target_date ? moment(this.target_date).format('YYYY-MM-DD') : '',
                    cluster: this.cluster,
                    sort: this[business + '_sort'],
                    orderby: this[business + '_orderby'],
                    threshold: this[business + '_threshold'],
                };

                let res = await this.getReportDailyCompare(post_data);

                if (res.code === 100000) {
                    this[business + '_compare_top20'] = res.data.list;
                    this.date_dict = res.data.date_dict;
                }

                this[business + '_compare_loading'] = false;
            },
            async get_report_daily_rank_data() {

            },
            handelSelectChange(type) {
                if (type === 'waitlist_compare') {
                    this.get_report_daily_compare_data('waitlist');
                } else if (type === 'reservation_compare') {
                    this.get_report_daily_compare_data('reservation');
                }
            },
            doShowLayer(sid) {
                this.show_merchant_detail_layer = true;
                this.select_sid = sid;
            },
            doHideLayer() {
                this.show_merchant_detail_layer = false;
            }
        }
    };
</script>
